// // ---------- Debounce ----------
// function debounce(fn, wait) {
//   let t;
//   return (...a) => {
//     clearTimeout(t);
//     t = setTimeout(() => fn.apply(this, a), wait);
//   };
// }
// const debouncedRunCartDiscountUI = debounce(runCartDiscountUI, 150);

// // ---------- Variant Cache ----------
// const variantCache = {};
// async function getComparePriceByVariantId(id) {
//   if (variantCache[id]) return variantCache[id];
//   try {
//     const r = await fetch(`/variants/${id}.js`);
//     const v = await r.json();
//     return (variantCache[id] = {
//       compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//       price: v.price / 100
//     });
//   } catch {
//     return null;
//   }
// }

// // ---------- Helpers ----------
// const LIP_TYPES = ['lip balm','lip care','lip'];
// const EXCLUDED_TYPES = ['combo','flashsale','flashstore','merch','free'];

// // IP SALE EXCLUDE LISTS
// const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
// const EXCLUDED_PRODUCT_IDS = [];

// function isIpSaleExcluded(item) {
//   return (
//     EXCLUDED_VARIANT_IDS.includes(item.variant_id) ||
//     EXCLUDED_PRODUCT_IDS.includes(item.product_id)
//   );
// }

// /* ================= NEW HELPER ================= */

// function hasAbove348Eligible(items) {
//   return items.some(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return false;
//     if (EXCLUDED_TYPES.includes(t)) return false;
//     if (LIP_TYPES.includes(t)) return false;

//     const price = variantCache[i.variant_id]?.price || 0;
//     return price > 348;
//   });
// }

// // ---------- Eligible (NON-LIP) ----------
// function getEligibleItems(items) {
//   const allowCheap = hasAbove348Eligible(items);

//   // 🔥 NEW: total calculate (same filtering base)
//   const total = items.reduce((sum, i) => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return sum;
//     if (EXCLUDED_TYPES.includes(t)) return sum;
//     if (LIP_TYPES.includes(t)) return sum;

//     const price = variantCache[i.variant_id]?.price || 0;

//     if (price <= 348 && !allowCheap) return sum;

//     return sum + price * i.quantity;
//   }, 0);

//   return items.filter(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return false;
//     if (EXCLUDED_TYPES.includes(t)) return false;
//     if (LIP_TYPES.includes(t)) return false;

//     const price = variantCache[i.variant_id]?.price || 0;

//     // 🔥 existing logic
//     if (price <= 348 && !allowCheap) return false;

//     // 🔥 NEW TOTAL CHECK (main condition)
//     if (total < 699) return false;

//     return true;
//   });
// }

// // ---------- Pricing Logic ----------
// function applyTieredPricing(cartItems) {

//   /* ================= LIP BUNDLE ================= */
//   const lipUnits = [];
//   cartItems.forEach(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return;
//     if (!LIP_TYPES.includes(t)) return;

//     const unit =
//       variantCache[i.variant_id]?.price ||
//       i.original_line_price / i.quantity / 100;

//     for (let q = 0; q < i.quantity; q++) {
//       lipUnits.push({ key: i.key, price: unit });
//     }
//   });

//   lipUnits.sort((a,b) => b.price - a.price);

//   const lipPairs = Math.floor(lipUnits.length / 2);
//   const lipDiscountTotal = lipPairs * 35000;

//   const lipDiscountMap = {};
//   if (lipPairs) {
//     const used = lipUnits.slice(0, lipPairs * 2);
//     const original = used.reduce((s,u)=>s+u.price,0);

//     used.forEach(u => {
//       lipDiscountMap[u.key] = lipDiscountMap[u.key] || { qty:0, price:u.price };
//       lipDiscountMap[u.key].qty++;
//     });

//     Object.values(lipDiscountMap).forEach(v => {
//       v.discounted_total = Math.round(
//         lipDiscountTotal * ((v.qty * v.price) / original)
//       );
//     });
//   }


//   /* ================= TIER ITEMS ================= */
//   const tierUnits = [];
//   getEligibleItems(cartItems).forEach(i => {
//     const unit =
//       variantCache[i.variant_id]?.compare_price ||
//       i.original_line_price / i.quantity / 100;

//     for (let q = 0; q < i.quantity; q++) {
//       tierUnits.push({ key: i.key, price: unit });
//     }
//   });

//   const tierPricing = {
//     2:69900,3:99900,4:129500,5:169800,
//     6:199800,8:259000
//   };

//   let discountedUnits = [], fullUnits = [], discountedTotal = 0;

//   if (tierUnits.length >= 8) {
//     discountedUnits = tierUnits.slice(0,8);
//     fullUnits = tierUnits.slice(8);
//     discountedTotal = tierPricing[8];
//   } else if (tierUnits.length === 7) {
//     discountedUnits = tierUnits.slice(0,6);
//     fullUnits = tierUnits.slice(6);
//     discountedTotal = tierPricing[6];
//   } else if (tierPricing[tierUnits.length]) {
//     discountedUnits = tierUnits;
//     discountedTotal = tierPricing[tierUnits.length];
//   } else {
//     fullUnits = tierUnits;
//   }

//   const discountedItems = [];
//   if (discountedUnits.length) {
//     const original = discountedUnits.reduce((s,u)=>s+u.price,0);
//     const map = {};
//     discountedUnits.forEach(u => {
//       map[u.key] = map[u.key] || { qty:0, price:u.price };
//       map[u.key].qty++;
//     });
//     Object.entries(map).forEach(([k,v]) => {
//       discountedItems.push({
//         key:k,
//         discounted_total: Math.round(
//           discountedTotal * ((v.qty * v.price) / original)
//         )
//       });
//     });
//   }

//   const nonDiscountedItems = [];

//   fullUnits.forEach(u => {
//     const f = nonDiscountedItems.find(x=>x.key===u.key);
//     f ? f.qty++ : nonDiscountedItems.push({ key:u.key, qty:1, price:u.price });
//   });

//   /* ================= MERGE LIP ================= */
//   Object.entries(lipDiscountMap).forEach(([k,v])=>{
//     discountedItems.push({ key:k, discounted_total:v.discounted_total });
//   });

//   const usedLipQty = lipPairs * 2;
//   const remainingLipUnits = lipUnits.slice(usedLipQty);
//   remainingLipUnits.forEach(u => {
//     const f = nonDiscountedItems.find(x => x.key === u.key);
//     f ? f.qty++ : nonDiscountedItems.push({ key:u.key, qty:1, price:u.price });
//   });

//   cartItems.forEach(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (EXCLUDED_TYPES.includes(t) || isIpSaleExcluded(i)) {
//       const unit =
//         variantCache[i.variant_id]?.price ||
//         i.original_line_price / i.quantity / 100;

//       for (let q=0;q<i.quantity;q++){
//         const f = nonDiscountedItems.find(x=>x.key===i.key);
//         f ? f.qty++ : nonDiscountedItems.push({ key:i.key, qty:1, price:unit });
//       }
//     }
//   });

//   return { discountedItems, nonDiscountedItems };
// }

// // ---------- UI ----------
// function updateCartPricesDisplay(data) {
//   const map = {};
//   data.discountedItems.forEach(i=>{
//     map[i.key]=(map[i.key]||0)+i.discounted_total;
//   });
//   data.nonDiscountedItems.forEach(i=>{
//     map[i.key]=(map[i.key]||0)+(i.price*i.qty*100);
//   });

//   document.querySelectorAll('.cart-drawer-unique-dr .cart-item__discounted-prices').forEach(c=>{

//     const key=c.dataset.key;
//     const qty=+c.dataset.quantity||1;
//     const v=variantCache[c.dataset.variantId];
//     const old=c.querySelector('.cart-item__old-price');
//     const fin=c.querySelector('.cart-item__final-price');

//     if(!fin) return;

//     if (EXCLUDED_VARIANT_IDS.includes(parseInt(c.dataset.variantId))) {
//       fin.textContent = `₹${(v.price*qty).toFixed(2)}`;
//       if (old) old.style.display = 'none';
//       return;
//     }

//     const original = old?.dataset.originalPrice
//       ? parseFloat(old.dataset.originalPrice)
//       : parseFloat(fin.textContent.replace(/[^\d.]/g,'')) || 0;

//     const final = map[key]!==undefined ? map[key]/100 : original;

//     if (old && final < original) {
//       old.textContent=`₹${original.toFixed(2)}`;
//       old.style.display='inline-block';
//       old.style.textDecoration='line-through';
//     } else if (old) {
//       old.style.display='block';
//     }

//     fin.textContent =
//       final < original
//         ? `₹${final.toFixed(2)}`
//         : `₹${(v.price * qty).toFixed(2)}`;
//   });
// }


// // ---------- Discount ----------
// function getTotalDiscount() {
//   let o = 0, f = 0;

//   document.querySelectorAll('.cart-drawer-unique-dr .cart-item__discounted-prices').forEach(i => {

//     const oldEl = i.querySelector('.cart-item__old-price');
//     const finalEl = i.querySelector('.cart-item__final-price');


//     if (!finalEl) return;

//     let oldPrice = oldEl 
//       ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, '')) 
//       : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//     let finalPrice = parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//     if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//       o += oldPrice;
//       f += finalPrice;
//     }

//   });

//   return o > f ? (o - f).toFixed(2) : '0.00';
// }


// // ---------- Main ----------
// async function runCartDiscountUI(){
//   const r=await fetch('/cart.js');
//   const cart=await r.json();
//   if(!cart.items.length) return;

//   await Promise.all(cart.items.map(i => getComparePriceByVariantId(i.variant_id)));
//   if(cart.item_count===1) return;

//   const data=applyTieredPricing(cart.items);
//   updateCartPricesDisplay(data);

//   const save=getTotalDiscount();
//   const tag=document.querySelector('.cart-drawer-unique-dr .promo-code-tag');
//   if(tag && save>0){
//     tag.style.display='block';
//     tag.textContent='You Save ₹'+save;
//   }
// }

// // ---------- Observers ----------
// document.addEventListener('DOMContentLoaded',debouncedRunCartDiscountUI);
// document.addEventListener('shopify:section:load',debouncedRunCartDiscountUI);
// new MutationObserver(debouncedRunCartDiscountUI)
//   .observe(document.body,{childList:true,subtree:true});


//   // ---------- Public API (reuse in customers-also-bought, etc.) ----------
// /** Given result of applyTieredPricing(), returns total in paise. */
// function getTotalFromPricingResult(data) {
//   let total = 0;
//   (data.discountedItems || []).forEach((i) => {
//     total += i.discounted_total || 0;
//   });
//   (data.nonDiscountedItems || []).forEach((i) => {
//     total += (i.price || 0) * (i.qty || 0) * 100;
//   });
//   return total;
// }

// window.DotKeyIpSale = {
//   getComparePriceByVariantId,
//   applyTieredPricing,
//   getEligibleItems,
//   hasAbove348Eligible,
//   isIpSaleExcluded,
//   getTotalFromPricingResult,
//   LIP_TYPES,
//   EXCLUDED_TYPES,
//   EXCLUDED_VARIANT_IDS,
//   EXCLUDED_PRODUCT_IDS,
// };


// (function () {
//   if (window.__DOTKEY_IPSALE_INIT__) return;
//   window.__DOTKEY_IPSALE_INIT__ = true;

//   // ---------- RAF Debounce ----------
//   function debounce(fn) {
//     let raf;
//     return function () {
//       const args = arguments;
//       cancelAnimationFrame(raf);
//       raf = requestAnimationFrame(function () {
//         fn.apply(null, args);
//       });
//     };
//   }

//   // ---------- Variant Cache ----------
//   const variantCache = Object.create(null);

//   async function getComparePriceByVariantId(id) {
//     if (variantCache[id]) return variantCache[id];

//     try {
//       const r = await fetch('/variants/' + id + '.js', {
//         credentials: 'same-origin',
//         cache: 'force-cache'
//       });

//       if (!r.ok) return null;

//       const v = await r.json();

//       variantCache[id] = {
//         compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//         price: v.price / 100
//       };

//       return variantCache[id];
//     } catch (e) {
//       return null;
//     }
//   }

//   // ---------- Constants ----------
//   const LIP_TYPES = ['lip balm', 'lip care', 'lip'];
//   const EXCLUDED_TYPES = ['combo', 'flashsale', 'flashstore', 'merch', 'free'];
//   const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
//   const EXCLUDED_PRODUCT_IDS = [];

//   // ---------- Helpers ----------
//   function isIpSaleExcluded(item) {
//     return (
//       EXCLUDED_VARIANT_IDS.indexOf(item.variant_id) !== -1 ||
//       EXCLUDED_PRODUCT_IDS.indexOf(item.product_id) !== -1
//     );
//   }

//   function hasAbove348Eligible(items) {
//     for (let i = 0; i < items.length; i++) {
//       const item = items[i];
//       const t = (item.product_type || '').toLowerCase();

//       if (isIpSaleExcluded(item)) continue;
//       if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
//       if (LIP_TYPES.indexOf(t) !== -1) continue;

//       const price = (variantCache[item.variant_id] || {}).price || 0;
//       if (price > 348) return true;
//     }

//     return false;
//   }

//   function getEligibleItems(items) {
//     const allowCheap = hasAbove348Eligible(items);
//     let total = 0;
//     const eligible = [];

//     for (let i = 0; i < items.length; i++) {
//       const item = items[i];
//       const t = (item.product_type || '').toLowerCase();

//       if (isIpSaleExcluded(item)) continue;
//       if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
//       if (LIP_TYPES.indexOf(t) !== -1) continue;

//       const price = (variantCache[item.variant_id] || {}).price || 0;

//       if (price <= 348 && !allowCheap) continue;

//       total += price * item.quantity;
//       eligible.push(item);
//     }

//     return total < 699 ? [] : eligible;
//   }

//   // ---------- Pricing Logic ----------
//   function applyTieredPricing(cartItems) {
//     const lipUnits = [];
//     const nonDiscountMap = {};
//     const lipDiscountMap = {};

//     for (let i = 0; i < cartItems.length; i++) {
//       const item = cartItems[i];
//       const t = (item.product_type || '').toLowerCase();

//       const unit =
//         (variantCache[item.variant_id] || {}).price ||
//         item.original_line_price / item.quantity / 100;

//       if (LIP_TYPES.indexOf(t) !== -1 && !isIpSaleExcluded(item)) {
//         for (let q = 0; q < item.quantity; q++) {
//           lipUnits.push({ key: item.key, price: unit });
//         }
//         continue;
//       }

//       if (EXCLUDED_TYPES.indexOf(t) !== -1 || isIpSaleExcluded(item)) {
//         if (!nonDiscountMap[item.key]) {
//           nonDiscountMap[item.key] = {
//             key: item.key,
//             qty: 0,
//             price: unit
//           };
//         }

//         nonDiscountMap[item.key].qty += item.quantity;
//       }
//     }

//     // ---------- Lip ----------
//     lipUnits.sort(function (a, b) {
//       return b.price - a.price;
//     });

//     const lipPairs = Math.floor(lipUnits.length / 2);
//     const lipDiscountTotal = lipPairs * 35000;

//     if (lipPairs) {
//       const used = lipUnits.slice(0, lipPairs * 2);
//       let original = 0;

//       used.forEach(function (u) {
//         original += u.price;

//         if (!lipDiscountMap[u.key]) {
//           lipDiscountMap[u.key] = {
//             qty: 0,
//             price: u.price
//           };
//         }

//         lipDiscountMap[u.key].qty++;
//       });

//       Object.keys(lipDiscountMap).forEach(function (k) {
//         const v = lipDiscountMap[k];

//         v.discounted_total = Math.round(
//           lipDiscountTotal * ((v.qty * v.price) / original)
//         );
//       });
//     }

//     // ---------- Tier ----------
//     const tierUnits = [];
//     const eligibleItems = getEligibleItems(cartItems);

//     for (let i = 0; i < eligibleItems.length; i++) {
//       const item = eligibleItems[i];

//       const unit =
//         (variantCache[item.variant_id] || {}).compare_price ||
//         item.original_line_price / item.quantity / 100;

//       for (let q = 0; q < item.quantity; q++) {
//         tierUnits.push({
//           key: item.key,
//           price: unit
//         });
//       }
//     }

//     const tierPricing = {
//       2: 69900,
//       3: 99900,
//       4: 129500,
//       5: 169800,
//       6: 199800,
//       8: 259000
//     };

//     let discountedUnits = [];
//     let fullUnits = [];
//     let discountedTotal = 0;

//     if (tierUnits.length >= 8) {
//       discountedUnits = tierUnits.slice(0, 8);
//       fullUnits = tierUnits.slice(8);
//       discountedTotal = tierPricing[8];
//     } else if (tierUnits.length === 7) {
//       discountedUnits = tierUnits.slice(0, 6);
//       fullUnits = tierUnits.slice(6);
//       discountedTotal = tierPricing[6];
//     } else if (tierPricing[tierUnits.length]) {
//       discountedUnits = tierUnits;
//       discountedTotal = tierPricing[tierUnits.length];
//     } else {
//       fullUnits = tierUnits;
//     }

//     const discountedItems = [];
//     const discountMap = {};

//     if (discountedUnits.length) {
//       let original = 0;

//       discountedUnits.forEach(function (u) {
//         original += u.price;

//         if (!discountMap[u.key]) {
//           discountMap[u.key] = {
//             qty: 0,
//             price: u.price
//           };
//         }

//         discountMap[u.key].qty++;
//       });

//       Object.keys(discountMap).forEach(function (k) {
//         const v = discountMap[k];

//         discountedItems.push({
//           key: k,
//           discounted_total: Math.round(
//             discountedTotal * ((v.qty * v.price) / original)
//           )
//         });
//       });
//     }

//     fullUnits.forEach(function (u) {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = {
//           key: u.key,
//           qty: 0,
//           price: u.price
//         };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     Object.keys(lipDiscountMap).forEach(function (k) {
//       discountedItems.push({
//         key: k,
//         discounted_total: lipDiscountMap[k].discounted_total
//       });
//     });

//     lipUnits.slice(lipPairs * 2).forEach(function (u) {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = {
//           key: u.key,
//           qty: 0,
//           price: u.price
//         };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     return {
//       discountedItems: discountedItems,
//       nonDiscountedItems: Object.values(nonDiscountMap)
//     };
//   }

//   // ---------- UI ----------
//   function updateCartPricesDisplay(data) {
//     const map = {};
//     const rows = document.querySelectorAll(
//       '.cart-drawer-unique-dr .cart-item__discounted-prices'
//     );

//     data.discountedItems.forEach(function (i) {
//       map[i.key] = (map[i.key] || 0) + i.discounted_total;
//     });

//     data.nonDiscountedItems.forEach(function (i) {
//       map[i.key] = (map[i.key] || 0) + i.price * i.qty * 100;
//     });

//     Array.prototype.forEach.call(rows, function (c) {
//       const key = c.dataset.key;
//       const qty = +c.dataset.quantity || 1;
//       const variantId = +c.dataset.variantId;

//       const v = variantCache[variantId];
//       if (!v) return;

//       const old = c.querySelector('.cart-item__old-price');
//       const fin = c.querySelector('.cart-item__final-price');

//       if (!fin) return;

//       if (EXCLUDED_VARIANT_IDS.indexOf(variantId) !== -1) {
//         fin.textContent = '₹' + (v.price * qty).toFixed(2);
//         if (old) old.style.display = 'none';
//         return;
//       }

//       const original =
//         old && old.dataset.originalPrice
//           ? parseFloat(old.dataset.originalPrice)
//           : parseFloat(fin.textContent.replace(/[^\d.]/g, '')) || 0;

//       const final = map[key] !== undefined ? map[key] / 100 : original;

//       if (old) {
//         if (final < original) {
//           old.textContent = '₹' + original.toFixed(2);
//           old.style.display = 'inline-block';
//           old.style.textDecoration = 'line-through';
//         } else {
//           old.style.display = 'none';
//         }
//       }

//       fin.textContent =
//         final < original
//           ? '₹' + final.toFixed(2)
//           : '₹' + (v.price * qty).toFixed(2);
//     });
//   }

//   // ---------- Discount ----------
//   function getTotalDiscount() {
//     let o = 0;
//     let f = 0;

//     const rows = document.querySelectorAll(
//       '.cart-drawer-unique-dr .cart-item__discounted-prices'
//     );

//     Array.prototype.forEach.call(rows, function (i) {
//       const oldEl = i.querySelector('.cart-item__old-price');
//       const finalEl = i.querySelector('.cart-item__final-price');

//       if (!finalEl) return;

//       const oldPrice = oldEl
//         ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, ''))
//         : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//       const finalPrice = parseFloat(
//         finalEl.textContent.replace(/[^\d.]/g, '')
//       );

//       if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//         o += oldPrice;
//         f += finalPrice;
//       }
//     });

//     return o > f ? (o - f).toFixed(2) : '0.00';
//   }

//   // ---------- Main ----------
//   async function runCartDiscountUI() {
//     try {
//       const r = await fetch('/cart.js', {
//         credentials: 'same-origin',
//         cache: 'no-store'
//       });

//       if (!r.ok) return;

//       const cart = await r.json();

//       if (!cart.items || !cart.items.length) return;

//       await Promise.all(
//         cart.items.map(function (i) {
//           return getComparePriceByVariantId(i.variant_id);
//         })
//       );

//       if (cart.item_count === 1) return;

//       const data = applyTieredPricing(cart.items);

//       updateCartPricesDisplay(data);

//       const save = getTotalDiscount();

//       const tag = document.querySelector(
//         '.cart-drawer-unique-dr .promo-code-tag'
//       );

//       if (tag) {
//         tag.style.display = save > 0 ? 'block' : 'none';
//         tag.textContent = save > 0 ? 'You Save ₹' + save : '';
//       }
//     } catch (e) {}
//   }

//   const debouncedRunCartDiscountUI = debounce(runCartDiscountUI);

//   // ---------- Events ----------
//   document.addEventListener(
//     'DOMContentLoaded',
//     debouncedRunCartDiscountUI
//   );

//   document.addEventListener(
//     'shopify:section:load',
//     debouncedRunCartDiscountUI
//   );

//   // ---------- Optimized Observer ----------
//   let lastMutation = 0;

//   const cartDrawerObserver = new MutationObserver(function () {
//     const now = Date.now();

//     if (now - lastMutation < 300) return;

//     lastMutation = now;

//     debouncedRunCartDiscountUI();
//   });

//   cartDrawerObserver.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   // ---------- API ----------
//   function getTotalFromPricingResult(data) {
//     let total = 0;

//     data.discountedItems.forEach(function (i) {
//       total += i.discounted_total || 0;
//     });

//     data.nonDiscountedItems.forEach(function (i) {
//       total += (i.price || 0) * (i.qty || 0) * 100;
//     });

//     return total;
//   }

//   window.DotKeyIpSale = {
//     getComparePriceByVariantId,
//     applyTieredPricing,
//     getEligibleItems,
//     hasAbove348Eligible,
//     isIpSaleExcluded,
//     getTotalFromPricingResult,
//     LIP_TYPES,
//     EXCLUDED_TYPES,
//     EXCLUDED_VARIANT_IDS,
//     EXCLUDED_PRODUCT_IDS
//   };
// })();


// (function () {
//   if (window.__DOTKEY_IPSALE_INIT__) return;
//   window.__DOTKEY_IPSALE_INIT__ = true;

//   function debounce(fn) {
//     let raf;
//     return function () {
//       const args = arguments;
//       cancelAnimationFrame(raf);
//       raf = requestAnimationFrame(function () {
//         fn.apply(null, args);
//       });
//     };
//   }

//   const variantCache = Object.create(null);

//   let cartRunning = false;
//   let queued = false;
//   let observerPaused = false;
//   let lastDrawerSignature = '';

//   async function getComparePriceByVariantId(id) {
//     if (variantCache[id]) return variantCache[id];

//     try {
//       const r = await fetch('/variants/' + id + '.js', {
//         credentials: 'same-origin',
//         cache: 'force-cache'
//       });

//       if (!r.ok) return null;

//       const v = await r.json();

//       variantCache[id] = {
//         compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//         price: v.price / 100
//       };

//       return variantCache[id];
//     } catch (e) {
//       return null;
//     }
//   }

//   const LIP_TYPES = ['lip balm', 'lip care', 'lip'];
//   const EXCLUDED_TYPES = ['combo', 'flashsale', 'flashstore', 'merch', 'free'];
//   const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
//   const EXCLUDED_PRODUCT_IDS = [];

//   function isIpSaleExcluded(item) {
//     return (
//       EXCLUDED_VARIANT_IDS.indexOf(item.variant_id) !== -1 ||
//       EXCLUDED_PRODUCT_IDS.indexOf(item.product_id) !== -1
//     );
//   }

//   function hasAbove348Eligible(items) {
//     for (let i = 0; i < items.length; i++) {
//       const item = items[i];
//       const t = (item.product_type || '').toLowerCase();

//       if (isIpSaleExcluded(item)) continue;
//       if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
//       if (LIP_TYPES.indexOf(t) !== -1) continue;

//       const price = (variantCache[item.variant_id] || {}).price || 0;
//       if (price > 348) return true;
//     }

//     return false;
//   }

//   function getEligibleItems(items) {
//     const allowCheap = hasAbove348Eligible(items);
//     let total = 0;
//     const eligible = [];

//     for (let i = 0; i < items.length; i++) {
//       const item = items[i];
//       const t = (item.product_type || '').toLowerCase();

//       if (isIpSaleExcluded(item)) continue;
//       if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
//       if (LIP_TYPES.indexOf(t) !== -1) continue;

//       const price = (variantCache[item.variant_id] || {}).price || 0;

//       if (price <= 348 && !allowCheap) continue;

//       total += price * item.quantity;
//       eligible.push(item);
//     }

//     return total < 699 ? [] : eligible;
//   }

//   function applyTieredPricing(cartItems) {
//     const lipUnits = [];
//     const nonDiscountMap = {};
//     const lipDiscountMap = {};

//     for (let i = 0; i < cartItems.length; i++) {
//       const item = cartItems[i];
//       const t = (item.product_type || '').toLowerCase();

//       const unit =
//         (variantCache[item.variant_id] || {}).price ||
//         item.original_line_price / item.quantity / 100;

//       if (LIP_TYPES.indexOf(t) !== -1 && !isIpSaleExcluded(item)) {
//         for (let q = 0; q < item.quantity; q++) {
//           lipUnits.push({ key: item.key, price: unit });
//         }
//         continue;
//       }

//       if (EXCLUDED_TYPES.indexOf(t) !== -1 || isIpSaleExcluded(item)) {
//         if (!nonDiscountMap[item.key]) {
//           nonDiscountMap[item.key] = { key: item.key, qty: 0, price: unit };
//         }

//         nonDiscountMap[item.key].qty += item.quantity;
//       }
//     }

//     lipUnits.sort(function (a, b) {
//       return b.price - a.price;
//     });

//     const lipPairs = Math.floor(lipUnits.length / 2);
//     const lipDiscountTotal = lipPairs * 35000;

//     if (lipPairs) {
//       const used = lipUnits.slice(0, lipPairs * 2);
//       let original = 0;

//       used.forEach(function (u) {
//         original += u.price;

//         if (!lipDiscountMap[u.key]) {
//           lipDiscountMap[u.key] = { qty: 0, price: u.price };
//         }

//         lipDiscountMap[u.key].qty++;
//       });

//       Object.keys(lipDiscountMap).forEach(function (k) {
//         const v = lipDiscountMap[k];

//         v.discounted_total = Math.round(
//           lipDiscountTotal * ((v.qty * v.price) / original)
//         );
//       });
//     }

//     const tierUnits = [];
//     const eligibleItems = getEligibleItems(cartItems);

//     for (let i = 0; i < eligibleItems.length; i++) {
//       const item = eligibleItems[i];

//       const unit =
//         (variantCache[item.variant_id] || {}).compare_price ||
//         item.original_line_price / item.quantity / 100;

//       for (let q = 0; q < item.quantity; q++) {
//         tierUnits.push({ key: item.key, price: unit });
//       }
//     }

//     const tierPricing = {
//       2: 69900,
//       3: 99900,
//       4: 129500,
//       5: 169800,
//       6: 199800,
//       8: 259000
//     };

//     let discountedUnits = [];
//     let fullUnits = [];
//     let discountedTotal = 0;

//     if (tierUnits.length >= 8) {
//       discountedUnits = tierUnits.slice(0, 8);
//       fullUnits = tierUnits.slice(8);
//       discountedTotal = tierPricing[8];
//     } else if (tierUnits.length === 7) {
//       discountedUnits = tierUnits.slice(0, 6);
//       fullUnits = tierUnits.slice(6);
//       discountedTotal = tierPricing[6];
//     } else if (tierPricing[tierUnits.length]) {
//       discountedUnits = tierUnits;
//       discountedTotal = tierPricing[tierUnits.length];
//     } else {
//       fullUnits = tierUnits;
//     }

//     const discountedItems = [];
//     const discountMap = {};

//     if (discountedUnits.length) {
//       let original = 0;

//       discountedUnits.forEach(function (u) {
//         original += u.price;

//         if (!discountMap[u.key]) {
//           discountMap[u.key] = { qty: 0, price: u.price };
//         }

//         discountMap[u.key].qty++;
//       });

//       Object.keys(discountMap).forEach(function (k) {
//         const v = discountMap[k];

//         discountedItems.push({
//           key: k,
//           discounted_total: Math.round(
//             discountedTotal * ((v.qty * v.price) / original)
//           )
//         });
//       });
//     }

//     fullUnits.forEach(function (u) {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     Object.keys(lipDiscountMap).forEach(function (k) {
//       discountedItems.push({
//         key: k,
//         discounted_total: lipDiscountMap[k].discounted_total
//       });
//     });

//     lipUnits.slice(lipPairs * 2).forEach(function (u) {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     return {
//       discountedItems: discountedItems,
//       nonDiscountedItems: Object.values(nonDiscountMap)
//     };
//   }

//   function updateCartPricesDisplay(data) {
//     observerPaused = true;

//     const map = {};
//     const rows = document.querySelectorAll(
//       '.cart-drawer-unique-dr .cart-item__discounted-prices'
//     );

//     if (!rows.length) {
//       observerPaused = false;
//       return;
//     }

//     data.discountedItems.forEach(function (i) {
//       map[i.key] = (map[i.key] || 0) + i.discounted_total;
//     });

//     data.nonDiscountedItems.forEach(function (i) {
//       map[i.key] = (map[i.key] || 0) + i.price * i.qty * 100;
//     });

//     Array.prototype.forEach.call(rows, function (c) {
//       const key = c.dataset.key;
//       const qty = +c.dataset.quantity || 1;
//       const variantId = +c.dataset.variantId;

//       const v = variantCache[variantId];
//       if (!v) return;

//       const old = c.querySelector('.cart-item__old-price');
//       const fin = c.querySelector('.cart-item__final-price');

//       if (!fin) return;

//       const original =
//         old && old.dataset.originalPrice
//           ? parseFloat(old.dataset.originalPrice)
//           : parseFloat(fin.textContent.replace(/[^\d.]/g, '')) || 0;

//       const final = map[key] !== undefined ? map[key] / 100 : original;

//       if (old) {
//         if (final < original) {
//           old.textContent = '₹' + original.toFixed(2);
//           old.style.display = 'inline-block';
//         } else {
//           old.style.display = 'none';
//         }
//       }

//       fin.textContent = '₹' + final.toFixed(2);
//     });

//     requestAnimationFrame(function () {
//       requestAnimationFrame(function () {
//         observerPaused = false;
//       });
//     });
//   }

//   function getTotalDiscount() {
//     let o = 0;
//     let f = 0;

//     document
//       .querySelectorAll('.cart-drawer-unique-dr .cart-item__discounted-prices')
//       .forEach(function (i) {
//         const oldEl = i.querySelector('.cart-item__old-price');
//         const finalEl = i.querySelector('.cart-item__final-price');

//         if (!finalEl) return;

//         const oldPrice = oldEl
//           ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, ''))
//           : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//         const finalPrice = parseFloat(
//           finalEl.textContent.replace(/[^\d.]/g, '')
//         );

//         if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//           o += oldPrice;
//           f += finalPrice;
//         }
//       });

//     return o > f ? (o - f).toFixed(2) : '0.00';
//   }

//   async function runCartDiscountUI(force) {
//     if (cartRunning) {
//       queued = true;
//       return;
//     }

//     cartRunning = true;

//     try {
//       const drawer = document.querySelector('.cart-drawer-unique-dr');
//       if (!drawer) return;

//       const signature = drawer.innerText.trim();

//       if (!force && signature === lastDrawerSignature) return;
//       lastDrawerSignature = signature;

//       const r = await fetch('/cart.js', {
//         credentials: 'same-origin',
//         cache: 'no-store'
//       });

//       if (!r.ok) return;

//       const cart = await r.json();

//       if (!cart.items || !cart.items.length) return;

//       await Promise.all(
//         cart.items.map(function (i) {
//           return getComparePriceByVariantId(i.variant_id);
//         })
//       );

//       const data = applyTieredPricing(cart.items);

//       updateCartPricesDisplay(data);

//       const save = getTotalDiscount();

//       const tag = document.querySelector(
//         '.cart-drawer-unique-dr .promo-code-tag'
//       );

//       if (tag) {
//         tag.style.display = save > 0 ? 'block' : 'none';
//         tag.textContent = save > 0 ? 'You Save ₹' + save : '';
//       }
//     } finally {
//       cartRunning = false;

//       if (queued) {
//         queued = false;
//         debouncedRunCartDiscountUI(true);
//       }
//     }
//   }

//   const debouncedRunCartDiscountUI = debounce(function (force) {
//     runCartDiscountUI(force);
//   });

//   function forceRun() {
//     lastDrawerSignature = '';
//     debouncedRunCartDiscountUI(true);
//   }

//   function attachDrawerObserver() {
//     const drawer = document.querySelector('.cart-drawer-unique-dr');

//     if (!drawer || drawer.__dotkeyObserved) return;

//     drawer.__dotkeyObserved = true;

//     const observer = new MutationObserver(function (mutations) {
//       if (observerPaused) return;

//       for (let i = 0; i < mutations.length; i++) {
//         if (
//           mutations[i].addedNodes.length ||
//           mutations[i].removedNodes.length ||
//           mutations[i].type === 'attributes'
//         ) {
//           forceRun();
//           break;
//         }
//       }
//     });

//     observer.observe(drawer, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//       attributeFilter: ['class', 'style']
//     });
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     forceRun();
//     setTimeout(forceRun, 500);
//     setTimeout(forceRun, 1200);
//     setTimeout(forceRun, 2200);
//     attachDrawerObserver();
//   });

//   document.addEventListener('shopify:section:load', function () {
//     forceRun();
//     attachDrawerObserver();
//   });

//   window.addEventListener('load', function () {
//     forceRun();
//     attachDrawerObserver();
//   });

//   const nativeFetch = window.fetch;

//   window.fetch = function () {
//     const url = arguments[0];

//     return nativeFetch.apply(this, arguments).then(function (res) {
//       try {
//         const requestURL =
//           typeof url === 'string' ? url : url && url.url ? url.url : '';

//         if (/\/cart\/(add|change|update|clear)\.js/.test(requestURL)) {
//           setTimeout(forceRun, 100);
//           setTimeout(forceRun, 400);
//           setTimeout(forceRun, 900);
//         }
//       } catch (e) {}

//       return res;
//     });
//   };

//   document.addEventListener('click', function (e) {
//     const trigger = e.target.closest(
//       '[href="/cart"], .header__icon--cart, .cart-icon-bubble, [data-cart-trigger], [data-drawer-trigger]'
//     );

//     if (!trigger) return;

//     setTimeout(forceRun, 120);
//     setTimeout(forceRun, 400);
//     setTimeout(forceRun, 900);
//     setTimeout(attachDrawerObserver, 500);
//   });

//   setInterval(function () {
//     const drawer = document.querySelector('.cart-drawer-unique-dr');

//     if (!drawer) {
//       attachDrawerObserver();
//       return;
//     }

//     const visible =
//       drawer.offsetWidth > 0 ||
//       drawer.offsetHeight > 0 ||
//       drawer.classList.contains('active') ||
//       drawer.classList.contains('open') ||
//       drawer.classList.contains('is-open');

//     if (visible) {
//       forceRun();
//     }
//   }, 1800);

//   window.DotKeyIpSale = {
//     getComparePriceByVariantId,
//     applyTieredPricing,
//     getEligibleItems,
//     hasAbove348Eligible,
//     isIpSaleExcluded
//   };
// })();

// (function () {
//   if (window.__DOTKEY_IPSALE_INIT__) return;
//   window.__DOTKEY_IPSALE_INIT__ = true;

//   function debounce(fn) {
//     let raf;
//     return function () {
//       const args = arguments;
//       cancelAnimationFrame(raf);
//       raf = requestAnimationFrame(function () {
//         fn.apply(null, args);
//       });
//     };
//   }

//   const variantCache = Object.create(null);

//   let cartRunning = false;
//   let queued = false;
//   let observerPaused = false;
//   let lastDrawerSignature = '';
//   let observerAttached = false;

//   async function getComparePriceByVariantId(id) {
//     if (variantCache[id]) return variantCache[id];

//     try {
//       const r = await fetch('/variants/' + id + '.js', {
//         credentials: 'same-origin',
//         cache: 'force-cache'
//       });

//       if (!r.ok) return null;

//       const v = await r.json();

//       variantCache[id] = {
//         compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//         price: v.price / 100
//       };

//       return variantCache[id];
//     } catch (e) {
//       return null;
//     }
//   }

//   const LIP_TYPES = ['lip balm', 'lip care', 'lip'];
//   const EXCLUDED_TYPES = ['combo', 'flashsale', 'flashstore', 'merch', 'free'];
//   const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
//   const EXCLUDED_PRODUCT_IDS = [];

//   function isIpSaleExcluded(item) {
//     return (
//       EXCLUDED_VARIANT_IDS.indexOf(item.variant_id) !== -1 ||
//       EXCLUDED_PRODUCT_IDS.indexOf(item.product_id) !== -1
//     );
//   }

//   function hasAbove348Eligible(items) {
//     for (let i = 0; i < items.length; i++) {
//       const item = items[i];
//       const t = (item.product_type || '').toLowerCase();

//       if (isIpSaleExcluded(item)) continue;
//       if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
//       if (LIP_TYPES.indexOf(t) !== -1) continue;

//       const price = (variantCache[item.variant_id] || {}).price || 0;
//       if (price > 348) return true;
//     }

//     return false;
//   }

//   function getEligibleItems(items) {
//     const allowCheap = hasAbove348Eligible(items);
//     let total = 0;
//     const eligible = [];

//     for (let i = 0; i < items.length; i++) {
//       const item = items[i];
//       const t = (item.product_type || '').toLowerCase();

//       if (isIpSaleExcluded(item)) continue;
//       if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
//       if (LIP_TYPES.indexOf(t) !== -1) continue;

//       const price = (variantCache[item.variant_id] || {}).price || 0;

//       if (price <= 348 && !allowCheap) continue;

//       total += price * item.quantity;
//       eligible.push(item);
//     }

//     return total < 699 ? [] : eligible;
//   }

//   function applyTieredPricing(cartItems) {
//     const lipUnits = [];
//     const nonDiscountMap = {};
//     const lipDiscountMap = {};

//     for (let i = 0; i < cartItems.length; i++) {
//       const item = cartItems[i];
//       const t = (item.product_type || '').toLowerCase();

//       const unit =
//         (variantCache[item.variant_id] || {}).price ||
//         item.original_line_price / item.quantity / 100;

//       if (LIP_TYPES.indexOf(t) !== -1 && !isIpSaleExcluded(item)) {
//         for (let q = 0; q < item.quantity; q++) {
//           lipUnits.push({ key: item.key, price: unit });
//         }
//         continue;
//       }

//       if (EXCLUDED_TYPES.indexOf(t) !== -1 || isIpSaleExcluded(item)) {
//         if (!nonDiscountMap[item.key]) {
//           nonDiscountMap[item.key] = { key: item.key, qty: 0, price: unit };
//         }

//         nonDiscountMap[item.key].qty += item.quantity;
//       }
//     }

//     lipUnits.sort(function (a, b) {
//       return b.price - a.price;
//     });

//     const lipPairs = Math.floor(lipUnits.length / 2);
//     const lipDiscountTotal = lipPairs * 35000;

//     if (lipPairs) {
//       const used = lipUnits.slice(0, lipPairs * 2);
//       let original = 0;

//       used.forEach(function (u) {
//         original += u.price;

//         if (!lipDiscountMap[u.key]) {
//           lipDiscountMap[u.key] = { qty: 0, price: u.price };
//         }

//         lipDiscountMap[u.key].qty++;
//       });

//       Object.keys(lipDiscountMap).forEach(function (k) {
//         const v = lipDiscountMap[k];

//         v.discounted_total = Math.round(
//           lipDiscountTotal * ((v.qty * v.price) / original)
//         );
//       });
//     }

//     const tierUnits = [];
//     const eligibleItems = getEligibleItems(cartItems);

//     for (let i = 0; i < eligibleItems.length; i++) {
//       const item = eligibleItems[i];

//       const unit =
//         (variantCache[item.variant_id] || {}).compare_price ||
//         item.original_line_price / item.quantity / 100;

//       for (let q = 0; q < item.quantity; q++) {
//         tierUnits.push({ key: item.key, price: unit });
//       }
//     }

//     const tierPricing = {
//       2: 69900,
//       3: 99900,
//       4: 129500,
//       5: 169800,
//       6: 199800,
//       8: 259000
//     };

//     let discountedUnits = [];
//     let fullUnits = [];
//     let discountedTotal = 0;

//     if (tierUnits.length >= 8) {
//       discountedUnits = tierUnits.slice(0, 8);
//       fullUnits = tierUnits.slice(8);
//       discountedTotal = tierPricing[8];
//     } else if (tierUnits.length === 7) {
//       discountedUnits = tierUnits.slice(0, 6);
//       fullUnits = tierUnits.slice(6);
//       discountedTotal = tierPricing[6];
//     } else if (tierPricing[tierUnits.length]) {
//       discountedUnits = tierUnits;
//       discountedTotal = tierPricing[tierUnits.length];
//     } else {
//       fullUnits = tierUnits;
//     }

//     const discountedItems = [];
//     const discountMap = {};

//     if (discountedUnits.length) {
//       let original = 0;

//       discountedUnits.forEach(function (u) {
//         original += u.price;

//         if (!discountMap[u.key]) {
//           discountMap[u.key] = { qty: 0, price: u.price };
//         }

//         discountMap[u.key].qty++;
//       });

//       Object.keys(discountMap).forEach(function (k) {
//         const v = discountMap[k];

//         discountedItems.push({
//           key: k,
//           discounted_total: Math.round(
//             discountedTotal * ((v.qty * v.price) / original)
//           )
//         });
//       });
//     }

//     fullUnits.forEach(function (u) {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     Object.keys(lipDiscountMap).forEach(function (k) {
//       discountedItems.push({
//         key: k,
//         discounted_total: lipDiscountMap[k].discounted_total
//       });
//     });

//     lipUnits.slice(lipPairs * 2).forEach(function (u) {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     return {
//       discountedItems: discountedItems,
//       nonDiscountedItems: Object.values(nonDiscountMap)
//     };
//   }

//   function updateCartPricesDisplay(data) {
//     observerPaused = true;

//     const map = {};
//     const rows = document.querySelectorAll(
//       '.cart-drawer-unique-dr .cart-item__discounted-prices'
//     );

//     if (!rows.length) {
//       observerPaused = false;
//       return;
//     }

//     data.discountedItems.forEach(function (i) {
//       map[i.key] = (map[i.key] || 0) + i.discounted_total;
//     });

//     data.nonDiscountedItems.forEach(function (i) {
//       map[i.key] = (map[i.key] || 0) + i.price * i.qty * 100;
//     });

//     Array.prototype.forEach.call(rows, function (c) {
//       const key = c.dataset.key;
//       const qty = +c.dataset.quantity || 1;
//       const variantId = +c.dataset.variantId;

//       const v = variantCache[variantId];
//       if (!v) return;

//       const old = c.querySelector('.cart-item__old-price');
//       const fin = c.querySelector('.cart-item__final-price');

//       if (!fin) return;

//       const original =
//         old && old.dataset.originalPrice
//           ? parseFloat(old.dataset.originalPrice)
//           : parseFloat(fin.textContent.replace(/[^\d.]/g, '')) || 0;

//       const final = map[key] !== undefined ? map[key] / 100 : original;

//       if (old) {
//         if (final < original) {
//           old.textContent = '₹' + original.toFixed(2);
//           old.style.display = 'inline-block';
//         } else {
//           old.style.display = 'none';
//         }
//       }

//       fin.textContent = '₹' + final.toFixed(2);
//     });

//     requestAnimationFrame(function () {
//       requestAnimationFrame(function () {
//         observerPaused = false;
//       });
//     });
//   }

//   function getTotalDiscount() {
//     let o = 0;
//     let f = 0;

//     document
//       .querySelectorAll('.cart-drawer-unique-dr .cart-item__discounted-prices')
//       .forEach(function (i) {
//         const oldEl = i.querySelector('.cart-item__old-price');
//         const finalEl = i.querySelector('.cart-item__final-price');

//         if (!finalEl) return;

//         const oldPrice = oldEl
//           ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, ''))
//           : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//         const finalPrice = parseFloat(
//           finalEl.textContent.replace(/[^\d.]/g, '')
//         );

//         if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//           o += oldPrice;
//           f += finalPrice;
//         }
//       });

//     return o > f ? (o - f).toFixed(2) : '0.00';
//   }

//   async function runCartDiscountUI(force) {
//     if (cartRunning) {
//       queued = true;
//       return;
//     }

//     cartRunning = true;

//     try {
//       const drawer = document.querySelector('.cart-drawer-unique-dr');
//       if (!drawer) return;

//       const signature = drawer.innerText.trim();

//       if (!force && signature === lastDrawerSignature) return;
//       lastDrawerSignature = signature;

//       const r = await fetch('/cart.js', {
//         credentials: 'same-origin',
//         cache: 'no-store'
//       });

//       if (!r.ok) return;

//       const cart = await r.json();

//       if (!cart.items || !cart.items.length) return;

//       await Promise.all(
//         cart.items.map(function (i) {
//           return getComparePriceByVariantId(i.variant_id);
//         })
//       );

//       const data = applyTieredPricing(cart.items);

//       updateCartPricesDisplay(data);

//       const save = getTotalDiscount();

//       const tag = document.querySelector(
//         '.cart-drawer-unique-dr .promo-code-tag'
//       );

//       if (tag) {
//         tag.style.display = save > 0 ? 'block' : 'none';
//         tag.textContent = save > 0 ? 'You Save ₹' + save : '';
//       }
//     } finally {
//       cartRunning = false;

//       if (queued) {
//         queued = false;
//         debouncedRunCartDiscountUI(true);
//       }
//     }
//   }

//   const debouncedRunCartDiscountUI = debounce(runCartDiscountUI);

//   function attachDrawerObserver() {
//     if (observerAttached) return;

//     const drawer = document.querySelector('.cart-drawer-unique-dr');
//     if (!drawer) return;

//     observerAttached = true;

//     const observer = new MutationObserver(function (mutations) {
//       if (observerPaused) return;

//       for (let i = 0; i < mutations.length; i++) {
//         if (mutations[i].addedNodes.length || mutations[i].removedNodes.length) {
//           requestAnimationFrame(function () {
//             requestAnimationFrame(function () {
//               debouncedRunCartDiscountUI(true);
//             });
//           });
//           break;
//         }
//       }
//     });

//     observer.observe(drawer, {
//       childList: true,
//       subtree: true
//     });
//   }

//   function initRun() {
//     attachDrawerObserver();

//     requestAnimationFrame(function () {
//       requestAnimationFrame(function () {
//         debouncedRunCartDiscountUI(true);
//       });
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initRun);
//   } else {
//     initRun();
//   }

//   document.addEventListener('shopify:section:load', initRun);

//   document.addEventListener('click', function (e) {
//     const trigger = e.target.closest(
//       '[href*="/cart"], .cart-icon-bubble, .header__icon--cart, .cart-drawer-trigger'
//     );

//     if (!trigger) return;

//     requestAnimationFrame(function () {
//       requestAnimationFrame(function () {
//         initRun();
//       });
//     });
//   });

//   const nativeFetch = window.fetch;

//   window.fetch = function () {
//     const url = arguments[0];

//     return nativeFetch.apply(this, arguments).then(function (res) {
//       try {
//         const requestUrl = typeof url === 'string' ? url : url && url.url;

//         if (
//           requestUrl &&
//           /\/cart\/(add|change|update|clear)\.js/.test(requestUrl)
//         ) {
//           requestAnimationFrame(function () {
//             requestAnimationFrame(function () {
//               debouncedRunCartDiscountUI(true);
//             });
//           });
//         }
//       } catch (e) {}

//       return res;
//     });
//   };

//   window.DotKeyIpSale = {
//     getComparePriceByVariantId,
//     applyTieredPricing,
//     getEligibleItems,
//     hasAbove348Eligible,
//     isIpSaleExcluded
//   };
// })();

(function () {
  if (window.__DOTKEY_IPSALE_INIT__) return;
  window.__DOTKEY_IPSALE_INIT__ = true;

  function debounce(fn) {
    let raf;
    return function () {
      const args = arguments;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        fn.apply(null, args);
      });
    };
  }

  const variantCache = Object.create(null);

  let cartRunning = false;
  let queued = false;
  let observerPaused = false;
  let lastCartSignature = '';
  let observerAttached = false;

  async function getComparePriceByVariantId(id) {
    if (variantCache[id]) return variantCache[id];

    try {
      const r = await fetch('/variants/' + id + '.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!r.ok) return null;

      const v = await r.json();

      variantCache[id] = {
        compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
        price: v.price / 100
      };

      return variantCache[id];
    } catch (e) {
      return null;
    }
  }

  const LIP_TYPES = ['lip balm', 'lip care', 'lip'];
  const EXCLUDED_TYPES = ['combo', 'flashsale', 'flashstore', 'merch', 'free'];
  const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
  const EXCLUDED_PRODUCT_IDS = [];

  function isIpSaleExcluded(item) {
    return (
      EXCLUDED_VARIANT_IDS.indexOf(item.variant_id) !== -1 ||
      EXCLUDED_PRODUCT_IDS.indexOf(item.product_id) !== -1
    );
  }

  function hasAbove348Eligible(items) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const t = (item.product_type || '').toLowerCase();

      if (isIpSaleExcluded(item)) continue;
      if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
      if (LIP_TYPES.indexOf(t) !== -1) continue;

      const price = (variantCache[item.variant_id] || {}).price || 0;

      if (price > 348) return true;
    }

    return false;
  }

  function getEligibleItems(items) {
    const allowCheap = hasAbove348Eligible(items);
    let total = 0;
    const eligible = [];

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const t = (item.product_type || '').toLowerCase();

      if (isIpSaleExcluded(item)) continue;
      if (EXCLUDED_TYPES.indexOf(t) !== -1) continue;
      if (LIP_TYPES.indexOf(t) !== -1) continue;

      const price = (variantCache[item.variant_id] || {}).price || 0;

      if (price <= 348 && !allowCheap) continue;

      total += price * item.quantity;
      eligible.push(item);
    }

    return total < 699 ? [] : eligible;
  }

  function applyTieredPricing(cartItems) {
    const lipUnits = [];
    const nonDiscountMap = {};
    const lipDiscountMap = {};

    for (let i = 0; i < cartItems.length; i++) {
      const item = cartItems[i];
      const t = (item.product_type || '').toLowerCase();

      const unit =
        (variantCache[item.variant_id] || {}).price ||
        item.original_line_price / item.quantity / 100;

      if (LIP_TYPES.indexOf(t) !== -1 && !isIpSaleExcluded(item)) {
        for (let q = 0; q < item.quantity; q++) {
          lipUnits.push({
            key: item.key,
            variant_id: item.variant_id,
            price: unit
          });
        }
        continue;
      }

      if (EXCLUDED_TYPES.indexOf(t) !== -1 || isIpSaleExcluded(item)) {
        const id = item.variant_id + '_' + item.key;

        if (!nonDiscountMap[id]) {
          nonDiscountMap[id] = {
            key: item.key,
            variant_id: item.variant_id,
            qty: 0,
            price: unit
          };
        }

        nonDiscountMap[id].qty += item.quantity;
      }
    }

    lipUnits.sort(function (a, b) {
      return b.price - a.price;
    });

    const lipPairs = Math.floor(lipUnits.length / 2);
    const lipDiscountTotal = lipPairs * 35000;

    if (lipPairs) {
      const used = lipUnits.slice(0, lipPairs * 2);
      let original = 0;

      used.forEach(function (u) {
        original += u.price;

        const id = u.variant_id + '_' + u.key;

        if (!lipDiscountMap[id]) {
          lipDiscountMap[id] = {
            key: u.key,
            variant_id: u.variant_id,
            qty: 0,
            price: u.price
          };
        }

        lipDiscountMap[id].qty++;
      });

      Object.keys(lipDiscountMap).forEach(function (k) {
        const v = lipDiscountMap[k];

        v.discounted_total = Math.round(
          lipDiscountTotal * ((v.qty * v.price) / original)
        );
      });
    }

    const tierUnits = [];
    const eligibleItems = getEligibleItems(cartItems);

    for (let i = 0; i < eligibleItems.length; i++) {
      const item = eligibleItems[i];

      const unit =
        (variantCache[item.variant_id] || {}).compare_price ||
        (variantCache[item.variant_id] || {}).price ||
        item.original_line_price / item.quantity / 100;

      for (let q = 0; q < item.quantity; q++) {
        tierUnits.push({
          key: item.key,
          variant_id: item.variant_id,
          price: unit
        });
      }
    }

    const tierPricing = {
      2: 69900,
      3: 99900,
      4: 129500,
      5: 169800,
      6: 199800,
      8: 259000
    };

    let discountedUnits = [];
    let fullUnits = [];
    let discountedTotal = 0;

    if (tierUnits.length >= 8) {
      discountedUnits = tierUnits.slice(0, 8);
      fullUnits = tierUnits.slice(8);
      discountedTotal = tierPricing[8];
    } else if (tierUnits.length === 7) {
      discountedUnits = tierUnits.slice(0, 6);
      fullUnits = tierUnits.slice(6);
      discountedTotal = tierPricing[6];
    } else if (tierPricing[tierUnits.length]) {
      discountedUnits = tierUnits;
      discountedTotal = tierPricing[tierUnits.length];
    } else {
      fullUnits = tierUnits;
    }

    const discountedItems = [];
    const discountMap = {};

    if (discountedUnits.length) {
      let original = 0;

      discountedUnits.forEach(function (u) {
        original += u.price;

        const id = u.variant_id + '_' + u.key;

        if (!discountMap[id]) {
          discountMap[id] = {
            key: u.key,
            variant_id: u.variant_id,
            qty: 0,
            price: u.price
          };
        }

        discountMap[id].qty++;
      });

      Object.keys(discountMap).forEach(function (k) {
        const v = discountMap[k];

        discountedItems.push({
          key: v.key,
          variant_id: v.variant_id,
          discounted_total: Math.round(
            discountedTotal * ((v.qty * v.price) / original)
          )
        });
      });
    }

    fullUnits.forEach(function (u) {
      const id = u.variant_id + '_' + u.key;

      if (!nonDiscountMap[id]) {
        nonDiscountMap[id] = {
          key: u.key,
          variant_id: u.variant_id,
          qty: 0,
          price: u.price
        };
      }

      nonDiscountMap[id].qty++;
    });

    Object.keys(lipDiscountMap).forEach(function (k) {
      discountedItems.push({
        key: lipDiscountMap[k].key,
        variant_id: lipDiscountMap[k].variant_id,
        discounted_total: lipDiscountMap[k].discounted_total
      });
    });

    lipUnits.slice(lipPairs * 2).forEach(function (u) {
      const id = u.variant_id + '_' + u.key;

      if (!nonDiscountMap[id]) {
        nonDiscountMap[id] = {
          key: u.key,
          variant_id: u.variant_id,
          qty: 0,
          price: u.price
        };
      }

      nonDiscountMap[id].qty++;
    });

    return {
      discountedItems: discountedItems,
      nonDiscountedItems: Object.values(nonDiscountMap)
    };
  }

  function updateCartPricesDisplay(data) {
    observerPaused = true;

    const map = {};
    const rows = document.querySelectorAll(
      '.cart-drawer-unique-dr .cart-item__discounted-prices'
    );

    if (!rows.length) {
      observerPaused = false;
      return;
    }

    data.discountedItems.forEach(function (i) {
      const id = i.variant_id + '_' + i.key;
      map[id] = (map[id] || 0) + i.discounted_total;
    });

    data.nonDiscountedItems.forEach(function (i) {
      const id = i.variant_id + '_' + i.key;
      map[id] = (map[id] || 0) + i.price * i.qty * 100;
    });

    Array.prototype.forEach.call(rows, function (c) {
      const key = c.dataset.key;
      const qty = +c.dataset.quantity || 1;
      const variantId = +c.dataset.variantId;
      const id = variantId + '_' + key;

      const v = variantCache[variantId];
      if (!v) return;

      const old = c.querySelector('.cart-item__old-price');
      const fin = c.querySelector('.cart-item__final-price');

      if (!fin) return;

      const compareUnit = v.compare_price || 0;
      const saleUnit = v.price || 0;

      const compareTotal = compareUnit * qty;
      const saleTotal = saleUnit * qty;

      const final = map[id] !== undefined ? map[id] / 100 : saleTotal;

      if (old) {
        if (compareUnit > saleUnit) {
          old.textContent = '₹' + compareTotal.toFixed(2);
          old.style.display = 'inline-block';
          old.style.textDecoration = 'line-through';
        } else {
          old.style.display = 'none';
        }
      }

      fin.textContent = '₹' + final.toFixed(2);
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        observerPaused = false;
      });
    });
  }

  function getTotalDiscount() {
    let o = 0;
    let f = 0;

    document
      .querySelectorAll('.cart-drawer-unique-dr .cart-item__discounted-prices')
      .forEach(function (i) {
        const oldEl = i.querySelector('.cart-item__old-price');
        const finalEl = i.querySelector('.cart-item__final-price');

        if (!finalEl) return;

        const oldPrice = oldEl
          ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, ''))
          : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

        const finalPrice = parseFloat(
          finalEl.textContent.replace(/[^\d.]/g, '')
        );

        if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
          o += oldPrice;
          f += finalPrice;
        }
      });

    return o > f ? (o - f).toFixed(2) : '0.00';
  }

  async function runCartDiscountUI(force) {
    if (cartRunning) {
      queued = true;
      return;
    }

    cartRunning = true;

    try {
      const r = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!r.ok) return;

      const cart = await r.json();

      const signature = cart.items.map(function (i) {
        return i.key + ':' + i.variant_id + ':' + i.quantity;
      }).join('|');

      if (!force && signature === lastCartSignature) return;

      lastCartSignature = signature;

      if (!cart.items.length) return;

      await Promise.all(
        cart.items.map(function (i) {
          return getComparePriceByVariantId(i.variant_id);
        })
      );

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          const data = applyTieredPricing(cart.items);

          updateCartPricesDisplay(data);

          const save = getTotalDiscount();

          const tag = document.querySelector(
            '.cart-drawer-unique-dr .promo-code-tag'
          );

          if (tag) {
            tag.style.display = save > 0 ? 'block' : 'none';
            tag.textContent = save > 0 ? 'You Save ₹' + save : '';
          }
        });
      });

    } finally {
      cartRunning = false;

      if (queued) {
        queued = false;
        debouncedRunCartDiscountUI(true);
      }
    }
  }

  const debouncedRunCartDiscountUI = debounce(runCartDiscountUI);

  function attachDrawerObserver() {
    const drawer = document.querySelector('.cart-drawer-unique-dr');

    if (!drawer) {
      observerAttached = false;
      return;
    }

    if (observerAttached) return;

    observerAttached = true;

    const observer = new MutationObserver(function () {
      if (observerPaused) return;
      debouncedRunCartDiscountUI(true);
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  function initRun() {
    observerAttached = false;
    attachDrawerObserver();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        debouncedRunCartDiscountUI(true);
      });
    });

    setTimeout(function () {
      debouncedRunCartDiscountUI(true);
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRun);
  } else {
    initRun();
  }

  document.addEventListener('shopify:section:load', initRun);

  window.addEventListener('pageshow', function () {
    initRun();
  });

  document.addEventListener('click', function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(initRun);
    });
  });

  const nativeFetch = window.fetch;

  window.fetch = function () {
    const url = arguments[0];

    return nativeFetch.apply(this, arguments).then(function (res) {
      try {
        const requestUrl = typeof url === 'string' ? url : url && url.url;

        if (
          requestUrl &&
          /\/cart\/(add|change|update|clear)\.js/.test(requestUrl)
        ) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              debouncedRunCartDiscountUI(true);
            });
          });
        }
      } catch (e) {}

      return res;
    });
  };

  window.DotKeyIpSale = {
    getComparePriceByVariantId,
    applyTieredPricing,
    getEligibleItems,
    hasAbove348Eligible,
    isIpSaleExcluded
  };
})();